
import { Component, Prop } from "vue-property-decorator";
import renderUtils from "@/components/RenderUtils";
import { IothubPropertyServiceProxy,ImportPropertiesDTO } from '@/service-proxies/app-v2/workStation.service-proxies'
import { importPropertiesByFile } from '@/api/api'
const ipsp = new IothubPropertyServiceProxy()
@Component
export default class IotInputModal extends renderUtils{
  @Prop({ default: undefined }) id: any
  @Prop({ default: false }) visible: Boolean
  textArea = ''
  loading = false
  radioValue = 1
  file = null
  fileList = []

  save(){
    if(this.radioValue === 1){
      this.loading = true
      const value = new ImportPropertiesDTO({
        gatewayAppId: this.id,
        properties: this.textArea
      })
      ipsp.importPropertiesByJson(value).then(() => {
        this.$message.success(this.$t('page_workstation_maintain_inport_success'))
        this.$emit('close')
        this.textArea = ''
        this.loading = false
      }).catch(() =>{
        this.loading = false
      })
    } else {
      this.handleOk()
    }
  }

  cancel(){
    this.textArea = ''
    this.$emit('close')
  }
  
  changeValue(value){
    this.textArea = value.target.value
  }
  changeInput(value){
    this.radioValue = value
  }

  beforeUpload(file: any) {
    const isGt20M = file.size / 1024 / 1024 > 20
    if (isGt20M) {
      this.$message.error(this.$t('page_my_document_notsupport'))
      return false
    }
    this.fileList = [...this.fileList,file]
    return false;
  }

  handleOk() {
    if(!this.fileList){
      this.$message.success(this.$t('page_my_document_select'))
    }
    this.loading = true
    const formData = new FormData()
    formData.append('file', this.fileList[0])
    formData.append('gatewayAppId', this.id)
    importPropertiesByFile(formData).then(() => {
      this.loading = false
      this.$emit('close')
    })
    setInterval(() => {
      this.loading = false
    }, 1000);
  }

  handleRemove(file) {
    const index = this.fileList.indexOf(file);
    const newFileList = this.fileList.slice();
    newFileList.splice(index, 1);
    this.fileList = newFileList;
  }

  render() {
    return (
      <a-modal
        title={this.$t('page_business_data_import_product')}
        visible={this.visible}
        onOk={() => this.save()}
        onCancel={() => this.cancel()}
        maskClosable={false}
        confirmLoading={this.loading}
      > 
        <div style="margin-bottom: 8px;">
          <a-radio-group onChange={value => this.changeInput(value.target.value)} default-value={this.radioValue}>
            <a-radio value={1}>
              Json文本
            </a-radio>
            <a-radio value={2}>
              文件
            </a-radio>
          </a-radio-group>
        </div>
        { this.radioValue == 1 ? 
          <a-textarea onChange={value => this.changeValue(value)} placeholder="请输入json" rows={16} /> : 
          <a-upload-dragger
            name="file"
            multiple={false}
            before-upload={file => this.beforeUpload(file)}
            file-list={this.fileList}
            remove={this.handleRemove}
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">{ this.$t('page_my_document_upload') }</p>
            <p class="ant-upload-title">{ this.$t('page_my_document_upload_here') }</p>
          </a-upload-dragger>
        }
      </a-modal>
    );
  }
}